import PrimaryCard from '@/components/Common/PrimaryCard'
import Spinner from '@/stories/components/Common/Spinner'

const FullScreenLoader = ({
  containerClass = 'h-[600px]',
  loadingMsg = 'Loading...',
  text,
}: {
  text?: string
  containerClass?: string
  loadingMsg?: string
}) => {
  return (
    <section className="mx-auto my-10 max-w-6xl bg-white">
      <PrimaryCard
        containerClass={`flex justify-center items-center ${containerClass}`}
      >
        <Spinner />
        <div className="mb-4 mt-10">{loadingMsg}</div>
        {text && <div className="text-center">{text}</div>}
      </PrimaryCard>
    </section>
  )
}

export default FullScreenLoader
